export default __webpack_public_path__ + "static/media/sugar.aa72037d.png";